import {postRequest} from "./helper"
export const contactUsListApi = (data) => postRequest('admin/contact-us',data);
export const contactUsReplayeApi = (data) => postRequest('admin/contact-us-replied',data);
export const getInTouchListApi = (data) => postRequest('list-getInTouch',data);



// WEBPACK FOOTER //
// ./src/api/Admin/ContactUs.js